import URLConfig from '@Config/urls/url.config';
import { Route } from 'react-router-dom';
import * as TransactionModule from '@Modules/transaction/pages';
import React from 'react';

const URL = URLConfig.TRANSACTION;

const TransactionRoutes = [
    <Route
      path={URL.CONSULT_UNPROCESSED_TRANSACTIONS}
      element={<TransactionModule.ConsultUnprocessedTransactions />}
    />,
    <Route
      path={URL.MAINTENANCE_UNPROCESSED_TRANSACTIONS}
      element={<TransactionModule.MaintenanceUnprocessedTransactions />}
    />,
    <Route
      path={URL.CONSULT_PROCESSED_TRANSACTIONS}
      element={<TransactionModule.ConsultProcessedTransactions />}
    />,
    <Route
      path={URL.CONSULT_DUPLICATED_TRANSACTIONS}
      element={<TransactionModule.ConsultDuplicatedTransactions />}
    />,
];

export default TransactionRoutes;
